import Tooltip from '@material-ui/core/Tooltip'
import Button from 'components/common/Button/Button'
import isEqual from 'lodash/isEqual'
import React, { useEffect, useState, useMemo } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { List } from 'immutable'
import moment from 'moment'
import { isEmpty, omit } from 'lodash'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import cn from 'classnames'
import { Collapse, Switch, TextField } from '@material-ui/core'
import { ReactComponent as TriggerIcon } from 'assets/img/trigger-icon.svg'
import { ReactComponent as TriggersInfoIcon } from 'assets/img/triggers-info-icon.svg'
import { ReactComponent as TriggersSiteIcon } from 'assets/img/triggers-site-icon.svg'
import { ReactComponent as TriggersSchedulingIcon } from 'assets/img/triggers-scheduling-icon.svg'
import { ReactComponent as ClockIcon } from 'assets/img/ic_clock.svg'
import SelectInput from 'components/common/Inputs/SelectInput'
import NavHeader from 'components/common/Inputs/SelectInput/NavHeader'
import { Flex, TimePickerPaper } from 'components/common/styles'
import Tabs from 'components/common/Inputs/SelectInput/Tabs'
import NestedSelectInput from 'components/common/Inputs/NestedSelectInput'
import {
  ADDITIONAL_DELAY_ACTIONS,
  DEFAULT_TRIGGER_START_OPTION,
  TRIGGER_ACTIONS,
  TRIGGERED_ACTIONS,
  VALUE_CUSTOM,
  VALUE_DAYS,
  VALUE_MONTHS,
  VALUE_OCCURRENCES,
  VALUE_WEEKS,
  VALUE_START,
  VALUE_WHEN_PARENT_COMPLETED,
  VALUE_WHEN_PARENT_INPUT,
  FIELD_TRIGGER_JOB_WORKFLOW,
  FIELD_TRIGGER_JOB_WORKFLOW_TASK,
  FIELD_TRIGGERED_JOB_WORKFLOW,
  FIELD_NAME,
  FIELD_TRIGGER_TYPE,
  FIELD_TRIGGER_ACTION,
  FIELD_TRIGGER_INPUTS,
  FIELD_SITE,
  FIELD_SITES,
  FIELD_START_DATE,
  FIELD_START_DATE_INPUT,
  FIELD_START_DELAY,
  FIELD_START_DELAY_DAYS,
  FIELD_DUE_DATE,
  FIELD_DUE_DATE_DAYS,
  FIELD_DUE_DATE_TIME,
  ADDITIONAL_END_DELAY_ACTIONS,
  VALUE_NEVER,
  VALUE_NO_DELAY,
  FIELD_TRIGGER_INPUT_VALUES,
  REGULAR_REPEAT_SCHEDULE,
  END_DATE,
  END_DATE_AFTER_TERM,
  END_DATE_AFTER_NUMBER,
  REPEAT_BY,
  FREQUENCY,
  REPEAT,
  START_TIME,
  WEEK_ORDINARY_NUMBER,
  DAY_OF_WEEK,
  DAY_OF_MONTH,
  VALUE_REGULAR,
  DAYS_OF_WEEK,
  FIELD_ACTIVE,
  TRIGGER_ASSIGNMENTS,
  VALUE_AFTER,
  FIELD_START_DELAY_SECONDS,
} from 'constants/jobsTriggers'
import { fetchSiteList } from 'reducers/logbookForm/reducer'
import { fetchWorkflowList } from 'reducers/myJobs/reducer'
import {
  DEFAULT_FORM_DATA,
  fetchTriggerExists,
  fetchTriggerInputs,
  createOrUpdateTriggerRule,
  clearTriggerInputs,
  fetchTriggerTableData,
  setFormData,
  toggleTriggerRule,
  fetchTriggerRule,
  fetchTriggerDefaultAssignments,
  fetchHierarchicalSiteGroups,
} from 'reducers/jobsTriggers/reducer'
import Psfs from 'lib/psfs/Psfs'
import withPromise from 'helpers/withPromise'
import { APP_LANGUAGES } from 'constants/index'
import { TYPE_INPUT_DATE, TYPE_INPUT_DATE_TIME } from 'helpers/jobs'
import ProfileHelper from 'helpers/profile'
import {
  StyledActionSection,
  StyledButtonHolder,
  StyledCondition,
  StyledErrorMessageHolder,
  StyledModal,
  StyledModalBoxSection,
  StyledModalOverlay,
  StyledName,
  StyledRuleSettings,
  StyledSwitch,
  StyledTitle,
  StyledFormSection,
  StyledModalTitle,
  StyledModalCloseButton,
  StyledModalSubtitle,
} from 'components/common/Modals/styles'
import {
  StyledErrorMessage,
  StyledInputHolder,
  StyledTimePicker,
} from 'components/common/Inputs/styles'
import usePrevious from 'hooks/usePrevious'
import AssignmentSubMenu from './AssignmentSubMenu'
import JobsTriggersAssignmentSection from './JobsTriggersAssignmentSection'
import TriggersSchedule from './TriggerSchedule/TriggersSchedule'
import messages from './translate'
import TriggerInputs from './TriggerInputs/TriggerInputs'
import { InputsValueIsText } from './styles'
import TriggerInputsSelect from './TriggerInputsSelect/TriggerInputsSelect'

const PARAMETER_ID = 'id'
const PARAMETER_VALUE = 'value'
const PARAMETER_LABEL = 'label'
const PARAMETER_TITLE = 'title'
const PARAMETER_OPTIONS = 'options'
const PARAMETER_NAME = 'name'
const PARAMETER_TASK = 'task'
const PARAMETER_INPUTS = 'inputs'
const JOBS_TAB = 0
const JOB_TASKS_TAB = 1
const TASKS_TAB = 2
const MAX_STOP_AFTER_TERM_VALUES = {
  MONTHS: 6,
  WEEKS: 24,
  DAYS: 180,
  OCCURRENCES: 180,
}

// eslint-disable-next-line max-statements
function AddTriggerMenu({
  intl: { formatMessage },
  isModalOpened,
  setIsModalOpened,
  fetchWorkflowList,
  workflowList,
  fetchTriggerInputs,
  triggerInputs,
  fetchSiteList,
  siteList,
  fetchTriggerExists,
  isFetching,
  createOrUpdateTriggerRule,
  clearTriggerInputs,
  fetchTriggerTableData,
  tablePsfs,
  stateFormData,
  setFormData,
  activeRuleId,
  setActiveRuleId,
  isLoading,
  toggleTriggerRule,
  fetchTriggerRule,
  locale,
  licensee: { usaTimeFormat },
  featureFlags,
  fetchTriggerDefaultAssignments,
  triggerDefaultAssignments,
  fetchHierarchicalSiteGroups,
  hierarchicalSiteGroups,
  isLoadingHierarchicalSiteGroups,
}) {
  const [isSiteCollapseOpened, setIsSiteCollapseOpened] = useState(false)
  const [isAssignmentCollapseOpened, setIsAssignmentCollapseOpened] = useState(
    false,
  )
  const [isSchedulingCollapseOpened, setIsSchedulingCollapseOpened] = useState(
    false,
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [isInvalidTitle, setIsInvalidTitle] = useState(false)
  const [selectedTab, setSelectedTab] = useState(JOBS_TAB)
  const [selectedJob, setSelectedJob] = useState(null)
  const [isAssignmentSubModalOpened, setIsAssignmentSubModalOpened] = useState(
    false,
  )
  const [startDateInputType, setStartDateInputType] = useState(null)
  const formData = stateFormData.toJS()
  const workflows = workflowList.toJS()
  const sites = siteList.toJS()
  const triggerInputsList = triggerInputs.toJS()
  const triggerDefaultAssignmentsList = triggerDefaultAssignments.toJS()

  const hierarchicalSiteGroupsData = useMemo(() => {
    if (!hierarchicalSiteGroups) return []

    const rawData = hierarchicalSiteGroups.toJS()
    const sitesWithGroups = rawData.filter(item => item?.children?.length)
    const sitesWithoutGroups = rawData.filter(item => !item?.children?.length)

    const groupedBySiteGroups = sitesWithGroups.reduce((acc, item) => {
      if (item?.children?.length) {
        const groupId = item.id
        const { name } = item
        const groupKey = `group_${groupId}`

        if (!acc[groupKey]) {
          acc[groupKey] = {
            id: groupKey,
            title: name,
            options: [],
          }
        }

        acc[groupKey].options = item?.children.map(site => ({
          value: site.id,
          label: site.name,
        }))
      }

      return acc
    }, {})

    const groups = Object.values(groupedBySiteGroups)
    if (sitesWithoutGroups.length > 0) {
      groups.push({
        id: 'other-sites',
        title: 'Other Sites',
        options: sitesWithoutGroups.map(site => ({
          value: site.id,
          label: site.name,
        })),
      })
    }

    if (groups.length === 0) {
      return [
        {
          id: 'all-sites',
          title: 'All Sites',
          options: rawData.map(site => ({
            value: site.id,
            label: site.name,
          })),
        },
      ]
    }

    return groups
  }, [hierarchicalSiteGroups])

  const taskList = triggerInputsList.map(({ task, task_id }) => ({
    title: task,
    id: task_id,
  }))
  const {
    triggerJobWorkflow,
    triggerJobWorkflowTask,
    triggeredJobWorkflow,
    triggerType,
    triggerAction,
    site,
    sites: selectedSites,
    name,
    startDelay,
    startDelayDays,
    startDelaySeconds,
    dueDate,
    dueDateDays,
    dueDateTime,
    active,
    id: triggerRuleId,
    startDate,
    triggerJobWorkflowInputValues,
    repeat,
    startTime,
    [REGULAR_REPEAT_SCHEDULE]: {
      frequency,
      repeatBy,
      endDateAfterNumber,
      endDateAfterTerm,
      endDate,
      daysOfWeek,
      dayOfWeek,
      weekOrdinalNumber,
      dayOfMonth,
    } = {},
  } = formData
  const isDefaultAssignment = isEqual(
    triggerDefaultAssignmentsList,
    formData[TRIGGER_ASSIGNMENTS],
  )
  const prevSite = usePrevious(site)
  const prevTriggeredJobWorkflow = usePrevious(triggeredJobWorkflow)
  const prevTriggerRuleId = usePrevious(triggerRuleId)
  const timepickerLocale = ProfileHelper.getCurrentLocale()
  const dueDateTimeIsValid = moment(dueDateTime).isValid()
  const customValidationErrors = Object.values(validationErrors).filter(Boolean)
  const isStartCondition = formData[FIELD_TRIGGER_ACTION] === VALUE_START

  useEffect(() => {
    if (isModalOpened) {
      fetchWorkflowList()
      if (featureFlags.TRIGGERS_MULTIPLE_SITES_SELECTOR) {
        fetchHierarchicalSiteGroups()
      }
    } else {
      setValidationErrors({})
      setFormData(DEFAULT_FORM_DATA)
      setIsSiteCollapseOpened(false)
      setIsAssignmentCollapseOpened(false)
      setIsSchedulingCollapseOpened(false)
      setIsInvalidTitle(false)
      clearTriggerInputs()
    }
  }, [isModalOpened])

  useEffect(() => {
    if (triggerJobWorkflow) {
      if (triggerJobWorkflowTask) {
        setSelectedJob(workflows.find(({ id }) => id === triggerJobWorkflow))
        setSelectedTab(TASKS_TAB)
      }

      const psfs = new Psfs()
      const filters = [triggerJobWorkflow]

      if (triggeredJobWorkflow) {
        filters.push(triggeredJobWorkflow)
      }

      psfs
        .addFilter('active', 1)
        .addFilter('visibleInUi', 1)
        .addFilter('workflow', filters, 'in')
        .addFields(['id', 'name'])

      withPromise(fetchSiteList, { psfs }).then(response => {
        if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
          const siteMatch = response.some(({ id: siteId }) => siteId === site)

          if (!siteMatch) {
            setFormData({
              ...formData,
              [FIELD_SITE]: null,
            })
          }
        }
      })
      fetchTriggerInputs({ id: triggerJobWorkflow })
    }
  }, [triggerJobWorkflow])

  useEffect(() => {
    if (triggeredJobWorkflow && featureFlags.TRIGGER_ASSIGNMENTS) {
      withPromise(fetchTriggerDefaultAssignments, {
        triggeredJobWorkflowId: triggeredJobWorkflow,
        siteId: site,
        shouldSetDefaultAssignmentsToForm:
          !triggerRuleId ||
          (prevTriggerRuleId &&
            (prevSite !== site ||
              prevTriggeredJobWorkflow !== triggeredJobWorkflow)),
      }).then(response => {
        if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
          setFormData({
            ...formData,
            [TRIGGER_ASSIGNMENTS]: response,
          })
        }
      })
    }
  }, [triggeredJobWorkflow, site, triggerRuleId, JSON.stringify(featureFlags)])

  useEffect(() => {
    if (selectedJob && selectedJob.id) {
      const psfs = new Psfs()

      psfs
        .addFilter('active', 1)
        .addFilter('visibleInUi', 1)
        .addFilter('workflow', selectedJob.id)
        .addFields(['id', 'name'])

      fetchSiteList({ psfs })
      fetchTriggerInputs({ id: selectedJob.id })
    }
  }, [selectedJob])

  useEffect(() => {
    if (triggeredJobWorkflow) {
      const psfs = new Psfs()
      const filters = [triggeredJobWorkflow]

      if (triggerJobWorkflow) {
        filters.push(triggerJobWorkflow)
      }

      psfs
        .addFilter('active', 1)
        .addFilter('visibleInUi', 1)
        .addFilter('workflow', filters, 'in')
        .addFields(['id', 'name'])

      withPromise(fetchSiteList, { psfs }).then(response => {
        if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
          const siteMatch = response.some(({ id: siteId }) => siteId === site)

          if (site && !siteMatch) {
            setFormData({
              ...formData,
              [FIELD_SITE]: null,
            })
          }
        }
      })
    }
  }, [triggeredJobWorkflow])

  useEffect(() => {
    if (triggerRuleId && site) {
      setIsSiteCollapseOpened(true)
    }
  }, [triggerRuleId, site])

  useEffect(() => {
    if (triggerRuleId) {
      setIsAssignmentCollapseOpened(!isDefaultAssignment)
    }
  }, [triggerRuleId, isDefaultAssignment])

  useEffect(() => {
    if (
      triggerRuleId &&
      (startDate !== VALUE_WHEN_PARENT_COMPLETED ||
        startDelay !== VALUE_NO_DELAY ||
        repeat !== VALUE_NEVER ||
        startDelayDays ||
        dueDate !== VALUE_NEVER ||
        dueDateDays ||
        dueDateTime ||
        endDateAfterNumber ||
        endDateAfterTerm)
    ) {
      setIsSchedulingCollapseOpened(true)
    }
  }, [
    triggerRuleId,
    startDate,
    startDelay,
    startDelayDays,
    dueDate,
    dueDateDays,
    dueDateTime,
    frequency,
    endDateAfterNumber,
    endDateAfterTerm,
  ])

  const handleCloseModal = () => {
    setIsModalOpened(false)
    setActiveRuleId(null)
    setSelectedTab(0)
    setSelectedJob(null)
  }

  const formatList = (
    list = [],
    value = PARAMETER_VALUE,
    label = PARAMETER_LABEL,
    needType = false,
  ) =>
    list.map(listItem => ({
      value: listItem[value],
      label: listItem[label],
      type: needType ? listItem.type : undefined,
    }))

  const formatListWithTranslation = (
    list = [],
    value = PARAMETER_VALUE,
    label = PARAMETER_LABEL,
  ) =>
    list.map(listItem => ({
      value: listItem[value],
      label: formatMessage(messages[listItem[label]]),
    }))

  const formatNestedList = (
    list = [],
    title = PARAMETER_TITLE,
    options = PARAMETER_OPTIONS,
    value = PARAMETER_VALUE,
    label = PARAMETER_LABEL,
  ) =>
    list.map(listItem => ({
      title: listItem[title],
      id: listItem.task_id,
      options: listItem[options].map(option => ({
        ...option,
        [value]: undefined,
        [label]: undefined,
        value: option[value],
        label: option[label],
      })),
    }))

  const formatTriggerAssignees = assignmentList =>
    assignmentList.map(({ site, tasks }) => ({
      site: site.id,
      tasks: tasks.map(task => ({
        id: task.id,
        assignedUserGroups: task.assignedUserGroups.map(({ id }) => id),
        assignedUsers: task.assignedUsers.map(({ id }) => id),
      })),
    }))

  const dateAndDatetimeInputs = []

  triggerInputsList.forEach(({ inputs }) => {
    inputs.forEach(input => {
      if ([TYPE_INPUT_DATE, TYPE_INPUT_DATE_TIME].includes(input.type)) {
        dateAndDatetimeInputs.push(input)
      }
    })
  })

  const formattedWorkflows = formatList(
    workflows,
    PARAMETER_ID,
    PARAMETER_TITLE,
  )
  const formattedTasks = formatList(taskList, PARAMETER_ID, PARAMETER_TITLE)
  const formattedSiteList = formatList(sites, PARAMETER_ID, PARAMETER_NAME)
  const formattedDateAndDatetimeInputs = formatList(
    dateAndDatetimeInputs,
    PARAMETER_ID,
    PARAMETER_TITLE,
    true,
  )
  const formattedTriggerActions = formatListWithTranslation(
    TRIGGER_ACTIONS,
    PARAMETER_VALUE,
    PARAMETER_LABEL,
  )
  const formattedTriggeredActions = formatListWithTranslation(
    TRIGGERED_ACTIONS,
    PARAMETER_VALUE,
    PARAMETER_LABEL,
  )
  const formattedAdditionalDelayActions = formatListWithTranslation(
    ADDITIONAL_DELAY_ACTIONS,
    PARAMETER_VALUE,
    PARAMETER_LABEL,
  )
  const formattedAdditionalDueDateActions = formatListWithTranslation(
    ADDITIONAL_END_DELAY_ACTIONS,
    PARAMETER_VALUE,
    PARAMETER_LABEL,
  )

  const defaultTriggerStartOption = formatListWithTranslation(
    [DEFAULT_TRIGGER_START_OPTION],
    PARAMETER_VALUE,
    PARAMETER_LABEL,
  )
  const triggerStartOptions = [
    ...defaultTriggerStartOption,
    ...formattedDateAndDatetimeInputs,
  ]
  const formattedTriggerInputsList = formatNestedList(
    triggerInputsList,
    PARAMETER_TASK,
    PARAMETER_INPUTS,
    PARAMETER_ID,
    PARAMETER_TITLE,
  )

  const isDateTimeInput = inputId =>
    triggerStartOptions.find(({ value }) => value === inputId)?.type ===
    TYPE_INPUT_DATE_TIME

  const stopAfterNumberValidationErrorCondition =
    (endDateAfterTerm === VALUE_DAYS &&
      endDateAfterNumber > MAX_STOP_AFTER_TERM_VALUES.DAYS) ||
    (endDateAfterTerm === VALUE_WEEKS &&
      endDateAfterNumber > MAX_STOP_AFTER_TERM_VALUES.WEEKS) ||
    (endDateAfterTerm === VALUE_MONTHS &&
      endDateAfterNumber > MAX_STOP_AFTER_TERM_VALUES.MONTHS) ||
    (endDateAfterTerm === VALUE_OCCURRENCES &&
      endDateAfterNumber > MAX_STOP_AFTER_TERM_VALUES.OCCURRENCES)
  const frequencyValidationError =
    (repeatBy === VALUE_DAYS && frequency > MAX_STOP_AFTER_TERM_VALUES.DAYS) ||
    (repeatBy === VALUE_WEEKS &&
      frequency > MAX_STOP_AFTER_TERM_VALUES.WEEKS) ||
    (repeatBy === VALUE_MONTHS &&
      frequency > MAX_STOP_AFTER_TERM_VALUES.MONTHS) ||
    (repeatBy === VALUE_OCCURRENCES &&
      frequency > MAX_STOP_AFTER_TERM_VALUES.OCCURRENCES)
  const startTimeValidationErrorCondition =
    !startTime &&
    !(
      isDateTimeInput(formData[FIELD_START_DATE_INPUT]) ||
      startDate === VALUE_WHEN_PARENT_COMPLETED
    ) &&
    startDateInputType !== TYPE_INPUT_DATE_TIME
  const daysOfWeekValidationErrorCondition =
    isStartCondition && repeatBy === VALUE_WEEKS && !daysOfWeek?.length
  const frequencyValidationErrorCondition =
    isStartCondition && repeat === VALUE_REGULAR && !frequency
  const repeatAndFrequencyValidationErrorCondition =
    !isStartCondition && (repeat !== VALUE_REGULAR || !repeatBy || !frequency)
  const startDelayItemsValidationErrorCondition =
    startDelay === VALUE_CUSTOM && !startDelayDays && !startDelaySeconds
  const workflowAndTaskValidationErrorCondition =
    !triggerJobWorkflow && !triggerJobWorkflowTask
  const nameValidationErrorCondition = isEmpty(name) || !name.en
  const inputValuesValidationErrorCondition = triggerJobWorkflowInputValues?.some(
    ({ values }) => values.length === 0,
  )
  const endDateAfterNumbersValidationErrorCondition =
    isStartCondition && repeat === VALUE_REGULAR && !endDateAfterNumber
  const dayOfWeekValidationErrorCondition =
    isStartCondition &&
    repeatBy === VALUE_MONTHS &&
    (dayOfWeek ? !weekOrdinalNumber : weekOrdinalNumber)
  const dayOfWeekAndMonthValidationErrorCondition =
    isStartCondition &&
    repeatBy === VALUE_MONTHS &&
    !dayOfWeek &&
    !weekOrdinalNumber &&
    !dayOfMonth
  const dueDateValidationErrorCondition =
    isStartCondition && repeat === VALUE_REGULAR && dueDate !== VALUE_CUSTOM
  const dueDateDaysValidationErrorCondition =
    dueDate === VALUE_CUSTOM &&
    (dueDateDays === null || dueDateDays < 0 || !Number.isInteger(dueDateDays))
  const dueDateTimeValidationErrorCondition =
    dueDate === VALUE_CUSTOM && (!dueDateTime || !dueDateTimeIsValid)

  const someFieldsValidationFailed =
    workflowAndTaskValidationErrorCondition ||
    !triggeredJobWorkflow ||
    nameValidationErrorCondition ||
    startDelayItemsValidationErrorCondition ||
    dueDateDaysValidationErrorCondition ||
    dueDateTimeValidationErrorCondition ||
    stopAfterNumberValidationErrorCondition ||
    inputValuesValidationErrorCondition ||
    frequencyValidationErrorCondition ||
    daysOfWeekValidationErrorCondition ||
    dayOfWeekAndMonthValidationErrorCondition ||
    dayOfWeekValidationErrorCondition ||
    startTimeValidationErrorCondition ||
    endDateAfterNumbersValidationErrorCondition ||
    repeatAndFrequencyValidationErrorCondition ||
    dueDateValidationErrorCondition ||
    frequencyValidationError

  const onChangeFormValue = (value, field) => {
    setFormData({
      ...formData,
      [field]: value,
    })
  }

  const onChangeTriggerName = ({ target: { value } }) => {
    const ruleNames = {}

    Object.keys(APP_LANGUAGES).forEach(lang => {
      ruleNames[lang] = value
    })

    onChangeFormValue(ruleNames, FIELD_NAME)
    setIsInvalidTitle(false)

    if (value) {
      const newValidationErrors = { ...validationErrors }

      delete newValidationErrors[FIELD_NAME]

      if (value.length >= 255) {
        setIsInvalidTitle(true)
      }

      setValidationErrors(newValidationErrors)
    } else {
      const newValidationErrors = {
        ...validationErrors,
        [FIELD_NAME]: '',
      }

      setValidationErrors(newValidationErrors)
    }
  }

  const inputsOptions = useMemo(
    () =>
      formData[FIELD_TRIGGER_JOB_WORKFLOW_TASK] &&
      formattedTriggerInputsList.length
        ? formattedTriggerInputsList.find(
            ({ id }) => id === formData[FIELD_TRIGGER_JOB_WORKFLOW_TASK],
          ).options
        : formattedTriggerInputsList.reduce(
            (acc, { title, options }) => [
              ...acc,
              ...options.map(option => ({
                ...option,
                task: title,
              })),
            ],
            [],
          ),
    [formData[FIELD_TRIGGER_JOB_WORKFLOW_TASK], formattedTriggerInputsList],
  )

  const filterInputValues = inputValues =>
    inputValues.map(inputValue => {
      const options = inputsOptions.find(
        input => input.value === inputValue.input,
      )?.options

      return {
        ...inputValue,
        ...(options
          ? {
              values: inputValue.values?.filter(v =>
                options.some(({ value }) => value === v),
              ),
            }
          : {}),
      }
    })

  const submitAction = () => {
    const resultFormData = triggerJobWorkflowTask
      ? formData
      : omit(formData, 'triggerJobWorkflowTask')

    // Prepare the data object with proper field handling based on feature flags
    const dataToSend = {
      ...resultFormData,
      id: undefined,
      [FIELD_DUE_DATE_TIME]: dueDateTime
        ? moment(formData.dueDateTime).format('HH:mm:ss')
        : null,
      [START_TIME]: startTime
        ? moment(formData.startTime).format('HH:mm:ss')
        : null,
      [FIELD_ACTIVE]: activeRuleId ? active : undefined,
      [TRIGGER_ASSIGNMENTS]: featureFlags.TRIGGER_ASSIGNMENTS
        ? formatTriggerAssignees(resultFormData[TRIGGER_ASSIGNMENTS])
        : undefined,
      [FIELD_TRIGGER_INPUT_VALUES]: filterInputValues(
        resultFormData[FIELD_TRIGGER_INPUT_VALUES],
      ),
    }

    // If using multiple sites selector, send sites array and remove the single site field
    if (featureFlags.TRIGGERS_MULTIPLE_SITES_SELECTOR) {
      dataToSend[FIELD_SITES] = selectedSites || []
      delete dataToSend[FIELD_SITE]
    } else {
      // If not using multiple sites, remove sites array and keep single site
      delete dataToSend[FIELD_SITES]
    }

    withPromise(createOrUpdateTriggerRule, {
      data: dataToSend,
      id: activeRuleId,
      successMessage: activeRuleId
        ? formatMessage(messages.ruleUpdateSuccess)
        : formatMessage(messages.ruleCreationSuccess),
      errorMessage: activeRuleId
        ? formatMessage(messages.ruleUpdateFailure)
        : formatMessage(messages.ruleCreationFailure),
    }).then(response => {
      if (
        response &&
        !Object.prototype.hasOwnProperty.call(response, 'error')
      ) {
        handleCloseModal()
        fetchTriggerTableData({ psfs: tablePsfs })
      } else {
        const { errors = [] } = response

        setValidationErrors({
          ...validationErrors,
          ...errors,
        })
      }
    })
  }

  // eslint-disable-next-line max-statements
  const handleSubmit = () => {
    if (someFieldsValidationFailed || isInvalidTitle) {
      const missingFields = {}

      if (workflowAndTaskValidationErrorCondition) {
        missingFields[FIELD_TRIGGER_JOB_WORKFLOW] = ''
        missingFields[FIELD_TRIGGER_JOB_WORKFLOW_TASK] = ''
      }

      if (!triggeredJobWorkflow) {
        missingFields[FIELD_TRIGGERED_JOB_WORKFLOW] = ''
      }

      if (nameValidationErrorCondition) {
        missingFields[FIELD_NAME] = ''
      }

      if (startDelayItemsValidationErrorCondition) {
        missingFields[FIELD_START_DELAY_DAYS] = ''
        missingFields[FIELD_START_DELAY_SECONDS] = ''
      }

      if (stopAfterNumberValidationErrorCondition) {
        missingFields[END_DATE_AFTER_NUMBER] = ''
      }

      if (frequencyValidationError) {
        missingFields[FREQUENCY] = ''
      }

      if (dueDateDaysValidationErrorCondition) {
        missingFields[FIELD_DUE_DATE_DAYS] = ''
      }

      if (dueDateTimeValidationErrorCondition) {
        missingFields[FIELD_DUE_DATE_TIME] = ''
      }

      if (inputValuesValidationErrorCondition) {
        missingFields[FIELD_TRIGGER_INPUT_VALUES] = ''
      }

      if (startTimeValidationErrorCondition) {
        setIsSchedulingCollapseOpened(true)
        missingFields[START_TIME] = ''
      }

      if (dueDateValidationErrorCondition) {
        missingFields[FIELD_DUE_DATE] = ''
      }

      if (frequencyValidationErrorCondition) {
        missingFields[FREQUENCY] = ''
      }

      if (daysOfWeekValidationErrorCondition) {
        missingFields[DAYS_OF_WEEK] = ''
      }

      if (dayOfWeekAndMonthValidationErrorCondition) {
        missingFields[DAY_OF_WEEK] = ''
        missingFields[WEEK_ORDINARY_NUMBER] = ''
        missingFields[DAY_OF_MONTH] = ''
      }

      if (dayOfWeekValidationErrorCondition) {
        missingFields[DAY_OF_WEEK] = ''
        missingFields[WEEK_ORDINARY_NUMBER] = ''
      }

      if (endDateAfterNumbersValidationErrorCondition) {
        missingFields[END_DATE_AFTER_NUMBER] = ''
      }

      if (repeatAndFrequencyValidationErrorCondition) {
        missingFields[REPEAT] = ''
        missingFields[REPEAT_BY] = ''
        missingFields[FREQUENCY] = ''
      }

      setValidationErrors(missingFields)
    } else if (activeRuleId) {
      submitAction()
    } else {
      let queryParams

      if (triggerJobWorkflowTask) {
        queryParams = {
          triggerJobWorkflow,
          triggerJobWorkflowTask,
          triggeredJobWorkflow,
          triggerType,
          triggerAction,
          site,
          exceptTriggerRule: null,
        }
      } else {
        queryParams = {
          triggerJobWorkflow,
          triggeredJobWorkflow,
          triggerType,
          triggerAction,
          site,
          exceptTriggerRule: null,
        }
      }

      withPromise(fetchTriggerExists, {
        queryParams,
        warningMessage: formatMessage(messages.ruleExistsMessage),
      }).then(() => {
        submitAction()
      })
    }
  }

  const buildAutomaticDueDateProperties = id => {
    const defaultProperties = {
      automaticDueDate: false,
      formData: {
        [FIELD_DUE_DATE]: VALUE_NEVER,
        [FIELD_DUE_DATE_DAYS]: null,
        [FIELD_DUE_DATE_TIME]: null,
      },
    }
    const selectedWorkflow = workflows.find(w => w.id === id)
    if (!selectedWorkflow) {
      return defaultProperties
    }
    const {
      automatic_due_date: automaticDueDate,
      automatic_due_date_days: automaticDueDateDays,
      automatic_due_date_time: automaticDueDateTime,
    } = selectedWorkflow
    if (!automaticDueDate) {
      return defaultProperties
    }
    const [hours, minutes, seconds] = automaticDueDateTime
      .split(':')
      .map(x => parseInt(x, 10))
    const endDateTime = moment()
      .add(automaticDueDateDays, 'day')
      .set('hours', hours)
      .set('minutes', minutes)
      .set('seconds', seconds)

    return {
      automaticDueDate,
      formData: {
        [FIELD_DUE_DATE]: VALUE_CUSTOM,
        [FIELD_DUE_DATE_DAYS]: automaticDueDateDays,
        [FIELD_DUE_DATE_TIME]: endDateTime,
      },
    }
  }

  const onChangeTriggerWorkflow = value => {
    const newValidationErrors = { ...validationErrors }

    delete newValidationErrors[FIELD_TRIGGER_JOB_WORKFLOW]
    delete newValidationErrors[FIELD_TRIGGER_JOB_WORKFLOW_TASK]

    setValidationErrors(newValidationErrors)

    const automaticDueDateProperties = buildAutomaticDueDateProperties(
      parseInt(value, 10),
    )

    setFormData({
      ...formData,
      [FIELD_TRIGGER_INPUTS]: [],
      [FIELD_TRIGGER_INPUT_VALUES]: [],
      [FIELD_TRIGGER_JOB_WORKFLOW]: value,
      [FIELD_TRIGGER_JOB_WORKFLOW_TASK]: null,
      ...automaticDueDateProperties.formData,
    })
    setIsSchedulingCollapseOpened(automaticDueDateProperties.automaticDueDate)
  }

  const onChangeTriggerWorkflowTask = value => {
    const newValidationErrors = { ...validationErrors }

    delete newValidationErrors[FIELD_TRIGGER_JOB_WORKFLOW]
    delete newValidationErrors[FIELD_TRIGGER_JOB_WORKFLOW_TASK]

    setValidationErrors(newValidationErrors)
    setFormData({
      ...formData,
      [FIELD_TRIGGER_INPUTS]: [],
      [FIELD_TRIGGER_INPUT_VALUES]: [],
      [FIELD_TRIGGER_JOB_WORKFLOW_TASK]: value,
    })
  }

  const clearWorkflow = () => {
    const newValidationErrors = { ...validationErrors }

    delete newValidationErrors[FIELD_TRIGGER_JOB_WORKFLOW]

    setValidationErrors(newValidationErrors)
    setFormData({
      ...formData,
      [FIELD_TRIGGER_JOB_WORKFLOW]: null,
    })
  }

  const clearTask = () => {
    const newValidationErrors = { ...validationErrors }

    delete newValidationErrors[FIELD_TRIGGER_JOB_WORKFLOW_TASK]

    setValidationErrors(newValidationErrors)
    setFormData({
      ...formData,
      [FIELD_TRIGGER_JOB_WORKFLOW_TASK]: null,
    })
  }

  const onChangeTriggeredWorkflow = value => {
    const newValidationErrors = { ...validationErrors }

    delete newValidationErrors[FIELD_TRIGGERED_JOB_WORKFLOW]

    setValidationErrors(newValidationErrors)
    onChangeFormValue(value, FIELD_TRIGGERED_JOB_WORKFLOW)
  }

  const onChangeTriggerAction = value => {
    const { triggerInputs } = formData
    const isStart = value === VALUE_START

    setFormData({
      ...formData,
      [FIELD_TRIGGER_INPUTS]: isStart ? triggerInputs : [],
      [FIELD_TRIGGER_ACTION]: value,
      [FIELD_DUE_DATE]: isStart ? dueDate : VALUE_NEVER,
      [FIELD_DUE_DATE_DAYS]: isStart ? dueDateDays : null,
      [FIELD_DUE_DATE_TIME]: isStart ? dueDateTime : null,
      [REGULAR_REPEAT_SCHEDULE]: isStart
        ? formData[REGULAR_REPEAT_SCHEDULE]
        : {
            frequency: formData[REGULAR_REPEAT_SCHEDULE].frequency,
            repeatBy: formData[REGULAR_REPEAT_SCHEDULE].repeatBy,
          },
    })
  }

  const onChangeTriggerStartsAt = value => {
    const isDefaultValue = value === VALUE_WHEN_PARENT_COMPLETED
    setStartDateInputType(
      dateAndDatetimeInputs.find(({ id }) => id === value)?.type,
    )

    setFormData({
      ...formData,
      [FIELD_START_DATE]: isDefaultValue ? value : VALUE_WHEN_PARENT_INPUT,
      [FIELD_START_DATE_INPUT]: isDefaultValue ? null : value,
      [START_TIME]: isDateTimeInput(value) ? null : formData[START_TIME],
    })
  }

  const onChangeRequiredNumberInput = (value, fieldName) => {
    const isNumberValue = value && !Number.isNaN(+value)

    onChangeFormValue(isNumberValue ? +value : null, fieldName)

    if (isNumberValue) {
      const newValidationErrors = { ...validationErrors }

      delete newValidationErrors[fieldName]

      setValidationErrors(newValidationErrors)
    } else {
      const newValidationErrors = {
        ...validationErrors,
        [fieldName]: '',
      }

      setValidationErrors(newValidationErrors)
    }
  }

  const onChangeOneOfRequiredDelayItem = (value, fieldName) => {
    const isNumberValue = value && !Number.isNaN(+value)

    onChangeFormValue(isNumberValue ? +value : null, fieldName)

    if (isNumberValue) {
      const newValidationErrors = { ...validationErrors }

      delete newValidationErrors[FIELD_START_DELAY_DAYS]
      delete newValidationErrors[FIELD_START_DELAY_SECONDS]

      setValidationErrors(newValidationErrors)
    } else {
      const newValidationErrors = {
        ...validationErrors,
        [FIELD_START_DELAY_DAYS]: '',
        [FIELD_START_DELAY_SECONDS]: '',
      }

      setValidationErrors(newValidationErrors)
    }
  }

  const onChangeRecurrence = value => {
    const isDefaultValue = value === VALUE_NEVER

    if (isStartCondition) {
      setFormData({
        ...formData,
        [REGULAR_REPEAT_SCHEDULE]: isDefaultValue
          ? {}
          : {
              [END_DATE]: VALUE_AFTER,
              [END_DATE_AFTER_TERM]: endDateAfterTerm || VALUE_MONTHS,
              [END_DATE_AFTER_NUMBER]: endDateAfterNumber || 3,
              [FREQUENCY]: frequency || 1,
              [REPEAT_BY]: repeatBy || VALUE_DAYS,
            },
        [REPEAT]: value,
      })
    } else {
      setFormData({
        ...formData,
        [REGULAR_REPEAT_SCHEDULE]: isDefaultValue
          ? {}
          : {
              [FREQUENCY]: frequency || 1,
              [REPEAT_BY]: repeatBy || VALUE_DAYS,
            },
        [REPEAT]: value,
      })

      const newValidationErrors = { ...validationErrors }

      delete newValidationErrors[REPEAT]
      delete newValidationErrors[REPEAT_BY]
      delete newValidationErrors[FREQUENCY]

      setValidationErrors(newValidationErrors)
    }

    if (isDefaultValue) {
      const newValidationErrors = { ...validationErrors }

      delete newValidationErrors[END_DATE_AFTER_NUMBER]

      setValidationErrors(newValidationErrors)
    }
  }

  const onChangeRegularRepeat = (value, field) => {
    const newValidationErrors = { ...validationErrors }

    if (
      field === WEEK_ORDINARY_NUMBER ||
      field === DAY_OF_WEEK ||
      field === DAY_OF_MONTH
    ) {
      delete newValidationErrors[WEEK_ORDINARY_NUMBER]
      delete newValidationErrors[DAY_OF_WEEK]
      delete newValidationErrors[DAY_OF_MONTH]
    } else {
      delete newValidationErrors[field]
    }

    setValidationErrors(newValidationErrors)

    if (field === REPEAT_BY) {
      setFormData({
        ...formData,
        [REGULAR_REPEAT_SCHEDULE]: {
          frequency,
          endDateAfterTerm,
          endDateAfterNumber,
          endDate,
          [field]: value,
        },
      })

      return
    }

    setFormData({
      ...formData,
      [REGULAR_REPEAT_SCHEDULE]: {
        ...formData[REGULAR_REPEAT_SCHEDULE],
        [field]: value,
      },
    })
  }

  const onClearMonthData = () => {
    setFormData({
      ...formData,
      [REGULAR_REPEAT_SCHEDULE]: {
        ...formData[REGULAR_REPEAT_SCHEDULE],
        [WEEK_ORDINARY_NUMBER]: undefined,
        [DAY_OF_WEEK]: undefined,
        [DAY_OF_MONTH]: undefined,
      },
    })
  }

  const onChangeDueDate = value => {
    const isCustomValue = value === VALUE_CUSTOM
    const newValidationErrors = { ...validationErrors }

    delete newValidationErrors[FIELD_DUE_DATE]

    setValidationErrors(newValidationErrors)

    setFormData({
      ...formData,
      [FIELD_DUE_DATE_DAYS]: isCustomValue ? 1 : null,
      [FIELD_DUE_DATE_TIME]: isCustomValue
        ? new Date().setHours(0, 0, 0, 0)
        : null,
      [FIELD_DUE_DATE]: value,
    })
  }

  const onChangeStatus = () => {
    if (isLoading) {
      return
    }

    withPromise(toggleTriggerRule, {
      active: !active,
      id: triggerRuleId,
      successfulMessage: formatMessage(messages.successfulTriggerUpdate),
      failedMessage: formatMessage(messages.failedTriggerUpdate),
    }).then(() => {
      fetchTriggerRule({ id: triggerRuleId })
      fetchTriggerTableData({ psfs: tablePsfs })
    })
  }

  const hasMissingRequiredFields = () =>
    Object.prototype.hasOwnProperty.call(
      validationErrors,
      FIELD_TRIGGER_JOB_WORKFLOW,
    ) ||
    Object.prototype.hasOwnProperty.call(
      validationErrors,
      FIELD_TRIGGERED_JOB_WORKFLOW,
    ) ||
    Object.prototype.hasOwnProperty.call(validationErrors, FIELD_NAME) ||
    Object.prototype.hasOwnProperty.call(
      validationErrors,
      FIELD_START_DELAY_DAYS,
    ) ||
    Object.prototype.hasOwnProperty.call(
      validationErrors,
      FIELD_DUE_DATE_DAYS,
    ) ||
    Object.prototype.hasOwnProperty.call(
      validationErrors,
      END_DATE_AFTER_NUMBER,
    ) ||
    Object.prototype.hasOwnProperty.call(
      validationErrors,
      FIELD_TRIGGER_INPUT_VALUES,
    ) ||
    Object.prototype.hasOwnProperty.call(validationErrors, FREQUENCY)

  const handleOverlayClick = () => {
    if (isAssignmentSubModalOpened) {
      setIsAssignmentSubModalOpened(false)
    } else {
      handleCloseModal()
    }
  }

  return (
    <>
      <StyledModalOverlay
        className={cn({ closed: !isModalOpened })}
        onClick={handleOverlayClick}
      />
      <StyledModal
        opened={isModalOpened}
        direction="column"
        isNewHeader={featureFlags.APP_HEADER_V2}
        customWidth="480px">
        <StyledFormSection>
          <StyledModalBoxSection>
            <Flex align="center" justify="space-between">
              <StyledModalTitle>
                {triggerRuleId
                  ? formatMessage(messages.editRuleName, {
                      ruleName: name[locale],
                    })
                  : formatMessage(messages.newTriggerRule)}
              </StyledModalTitle>
              <StyledModalCloseButton onClick={handleCloseModal} />
            </Flex>
          </StyledModalBoxSection>
          <StyledModalBoxSection>
            <StyledRuleSettings>
              <StyledTitle marginBottom="16">
                <TriggerIcon />
                {formatMessage(messages.triggerOptions)}
              </StyledTitle>
              <StyledCondition align="center" wrap="wrap">
                <StyledName>{formatMessage(messages.when)}</StyledName>
                <SelectInput
                  required
                  isValidationFailed={Object.prototype.hasOwnProperty.call(
                    validationErrors,
                    FIELD_TRIGGER_JOB_WORKFLOW,
                  )}
                  disabled={isFetching}
                  hasSearchField
                  label={formatMessage(messages.selectJobTask)}
                  options={selectedJob ? formattedTasks : formattedWorkflows}
                  value={
                    selectedJob ? triggerJobWorkflowTask : triggerJobWorkflow
                  }
                  header={() =>
                    selectedTab < 2 ? (
                      <Tabs
                        tabs={[
                          formatMessage(messages.job),
                          formatMessage(messages.task),
                        ]}
                        handleTabChange={index => {
                          setSelectedTab(index)
                          clearTask()
                          clearWorkflow()
                          setSelectedJob(null)
                        }}
                        selectedTab={selectedTab}
                      />
                    ) : (
                      <NavHeader
                        jobName={(selectedJob && selectedJob.title) || ''}
                        handleBack={() => {
                          setSelectedTab(JOB_TASKS_TAB)
                          setSelectedJob(null)
                          clearTask()
                        }}
                      />
                    )
                  }
                  isNavItems={selectedTab === JOB_TASKS_TAB}
                  onChange={value => {
                    if (selectedTab === JOBS_TAB) {
                      onChangeTriggerWorkflow(value)

                      return
                    }

                    onChangeTriggerWorkflowTask(value)
                  }}
                  onJobNavigate={({ value, label }) => {
                    setSelectedTab(TASKS_TAB)
                    setSelectedJob({ id: value, title: label })
                    onChangeTriggerWorkflow(value)
                  }}
                />
                <SelectInput
                  disabled={isFetching}
                  label={formatMessage(messages.selectJob)}
                  options={formattedTriggerActions}
                  value={formData[FIELD_TRIGGER_TYPE]}
                  onChange={value =>
                    onChangeFormValue(value, FIELD_TRIGGER_TYPE)
                  }
                />
              </StyledCondition>
              {triggerJobWorkflow && (
                <StyledCondition align="center" wrap="wrap">
                  {formatMessage(messages.andInputs)}
                  <TriggerInputsSelect
                    isTaskSelected={!!formData[FIELD_TRIGGER_JOB_WORKFLOW_TASK]}
                    isDisabled={
                      isFetching || !formattedTriggerInputsList.length
                    }
                    label={formatMessage(messages.selectInputs)}
                    onChangeFormValue={onChangeFormValue}
                    formattedTriggerInputsList={formattedTriggerInputsList}
                    selectedInputs={formData[FIELD_TRIGGER_INPUT_VALUES].map(
                      ({ input }) => input,
                    )}
                    inputs={inputsOptions}
                    inputValues={filterInputValues(
                      formData[FIELD_TRIGGER_INPUT_VALUES],
                    )}
                  />
                  <InputsValueIsText>
                    {formatMessage(messages.valueIs)}
                  </InputsValueIsText>
                </StyledCondition>
              )}
              {!!formData[FIELD_TRIGGER_INPUT_VALUES] &&
                !!formData[FIELD_TRIGGER_INPUT_VALUES].length && (
                  <TriggerInputs
                    setValidationErrors={setValidationErrors}
                    inputs={inputsOptions.filter(input =>
                      formData[FIELD_TRIGGER_INPUT_VALUES].map(selectedInput =>
                        selectedInput.input.toString(),
                      ).includes(input.value.toString()),
                    )}
                    formatMessage={formatMessage}
                    onChangeFormValue={onChangeFormValue}
                    selectedInputs={formData[FIELD_TRIGGER_INPUT_VALUES]}
                    validationErrors={validationErrors}
                  />
                )}
              <StyledCondition align="center" wrap="wrap">
                <StyledName>{formatMessage(messages.then)}</StyledName>
                <SelectInput
                  disabled={isFetching}
                  label={formatMessage(messages.selectJob)}
                  options={formattedTriggeredActions}
                  value={formData[FIELD_TRIGGER_ACTION]}
                  onChange={value => {
                    onChangeTriggerAction(value)
                  }}
                />
                <SelectInput
                  required
                  isValidationFailed={Object.prototype.hasOwnProperty.call(
                    validationErrors,
                    FIELD_TRIGGERED_JOB_WORKFLOW,
                  )}
                  disabled={isFetching}
                  hasSearchField
                  label={formatMessage(messages.selectJob)}
                  options={formattedWorkflows}
                  value={formData[FIELD_TRIGGERED_JOB_WORKFLOW]}
                  onChange={value => {
                    onChangeTriggeredWorkflow(value)
                  }}
                />
              </StyledCondition>
              {isStartCondition && (
                <StyledCondition align="center" wrap="wrap">
                  <StyledName>
                    {formatMessage(messages.usingReceivedData)}
                  </StyledName>
                  <NestedSelectInput
                    disabled={isFetching || !formattedTriggerInputsList.length}
                    multiple
                    hasSearchField
                    label={formatMessage(messages.noData)}
                    options={formattedTriggerInputsList}
                    value={formData[FIELD_TRIGGER_INPUTS]}
                    onChange={value =>
                      onChangeFormValue(value, FIELD_TRIGGER_INPUTS)
                    }
                  />
                </StyledCondition>
              )}
              <StyledCondition align="center" wrap="wrap">
                <StyledName>{formatMessage(messages.enterRuleName)}</StyledName>
                <StyledInputHolder>
                  <TextField
                    required
                    className={cn({
                      error:
                        Object.prototype.hasOwnProperty.call(
                          validationErrors,
                          FIELD_NAME,
                        ) || isInvalidTitle,
                    })}
                    placeholder={formatMessage(
                      messages.triggerRuleNamePlaceholder,
                    )}
                    disabled={isFetching}
                    value={formData[FIELD_NAME].en || ''}
                    onChange={onChangeTriggerName}
                  />
                  {Object.prototype.hasOwnProperty.call(
                    validationErrors,
                    FIELD_NAME,
                  ) && (
                    <Tooltip
                      title={formatMessage(messages.checkRuleNameMessage)}>
                      <StyledErrorMessage>
                        {formatMessage(messages.checkRuleNameMessage)}
                      </StyledErrorMessage>
                    </Tooltip>
                  )}
                  {isInvalidTitle && (
                    <Tooltip title={formatMessage(messages.invalidTitle)}>
                      <StyledErrorMessage>
                        {formatMessage(messages.invalidTitle)}
                      </StyledErrorMessage>
                    </Tooltip>
                  )}
                </StyledInputHolder>
              </StyledCondition>
            </StyledRuleSettings>
          </StyledModalBoxSection>
          <StyledModalBoxSection>
            <StyledModalSubtitle>
              {formatMessage(messages.additionalSettings)}
            </StyledModalSubtitle>
            <StyledRuleSettings>
              <StyledTitle
                expandable
                opened={isSiteCollapseOpened}
                onClick={() => {
                  setIsSiteCollapseOpened(!isSiteCollapseOpened)
                }}>
                <TriggersSiteIcon />
                {formatMessage(messages.site)}
              </StyledTitle>
              <Collapse in={isSiteCollapseOpened}>
                <StyledCondition align="center" wrap="wrap">
                  <StyledName>
                    {formatMessage(messages.applyToSites)}
                  </StyledName>
                  {featureFlags.TRIGGERS_MULTIPLE_SITES_SELECTOR ? (
                    <NestedSelectInput
                      disabled={
                        isFetching ||
                        isLoadingHierarchicalSiteGroups ||
                        !hierarchicalSiteGroupsData.length
                      }
                      multiple
                      hasSearchField
                      hasSelectAllOption
                      groupSelectable
                      hasClearOption
                      label={formatMessage(messages.site)}
                      options={hierarchicalSiteGroupsData}
                      value={
                        // eslint-disable-next-line no-nested-ternary
                        Array.isArray(selectedSites)
                          ? selectedSites.length === 0 && site
                            ? [site]
                            : selectedSites
                          : []
                      }
                      onChange={values => {
                        const normalizeValue = value => String(value)

                        const isGroupId = value =>
                          hierarchicalSiteGroupsData.some(
                            group =>
                              normalizeValue(group.id) ===
                              normalizeValue(value),
                          )

                        const normalizedCurrentSites = Array.isArray(
                          selectedSites,
                        )
                          ? selectedSites.map(normalizeValue)
                          : [normalizeValue(selectedSites)]
                        const selectedGroups = values.filter(value =>
                          isGroupId(value),
                        )

                        if (selectedGroups.length > 0) {
                          let finalSelectedSites = [...normalizedCurrentSites]

                          selectedGroups.forEach(groupId => {
                            const group = hierarchicalSiteGroupsData.find(
                              g =>
                                normalizeValue(g.id) ===
                                normalizeValue(groupId),
                            )

                            if (group) {
                              const groupSites = group.options.map(option =>
                                normalizeValue(option.value),
                              )
                              const allGroupSitesSelected = groupSites.every(
                                siteId =>
                                  normalizedCurrentSites.includes(siteId),
                              )

                              if (allGroupSitesSelected) {
                                finalSelectedSites = finalSelectedSites.filter(
                                  siteId => !groupSites.includes(siteId),
                                )
                              } else {
                                groupSites.forEach(siteId => {
                                  if (!finalSelectedSites.includes(siteId)) {
                                    finalSelectedSites.push(siteId)
                                  }
                                })
                              }
                            }
                          })
                          const valuesToSet =
                            finalSelectedSites.map(value => Number(value)) || []
                          onChangeFormValue(valuesToSet, FIELD_SITES)
                        } else {
                          const valuesToSet =
                            values.map(value => Number(value)) || []
                          onChangeFormValue(valuesToSet, FIELD_SITES)
                        }
                      }}
                      isLoading={isLoadingHierarchicalSiteGroups}
                    />
                  ) : (
                    <SelectInput
                      disabled={isFetching || !formattedSiteList.length}
                      hasClearOption
                      label={formatMessage(messages.site)}
                      options={formattedSiteList}
                      value={formData[FIELD_SITE]}
                      onChange={value => onChangeFormValue(value, FIELD_SITE)}
                    />
                  )}
                </StyledCondition>
              </Collapse>
            </StyledRuleSettings>
          </StyledModalBoxSection>
          {featureFlags.TRIGGER_ASSIGNMENTS && (
            <JobsTriggersAssignmentSection
              isOpened={isAssignmentCollapseOpened}
              setIsOpened={setIsAssignmentCollapseOpened}
              isDefaultAssignment={isDefaultAssignment}
              setIsAssignmentSubModalOpened={setIsAssignmentSubModalOpened}
              formData={formData}
            />
          )}
          <StyledModalBoxSection>
            <StyledRuleSettings>
              <StyledTitle
                expandable
                opened={isSchedulingCollapseOpened}
                onClick={() => {
                  setIsSchedulingCollapseOpened(!isSchedulingCollapseOpened)
                }}>
                <TriggersSchedulingIcon />
                {formatMessage(messages.scheduling)}
              </StyledTitle>
              <Collapse in={isSchedulingCollapseOpened}>
                <TriggersSchedule
                  isFetching={isFetching}
                  onChangeRecurrence={onChangeRecurrence}
                  formData={formData}
                  isStartCondition={isStartCondition}
                  validationErrors={validationErrors}
                  onChangeRegularRepeat={onChangeRegularRepeat}
                  onClearMonthData={onClearMonthData}
                />
                <StyledCondition align="center" wrap="wrap">
                  <StyledName>
                    {formatMessage(messages.triggerStartsAt)}
                  </StyledName>
                  <SelectInput
                    disabled={isFetching}
                    label={formatMessage(messages.triggerStartsAt)}
                    options={triggerStartOptions}
                    value={
                      formData[FIELD_START_DATE] === VALUE_WHEN_PARENT_COMPLETED
                        ? formData[FIELD_START_DATE]
                        : formData[FIELD_START_DATE_INPUT]
                    }
                    onChange={onChangeTriggerStartsAt}
                    customWidth="140px"
                  />
                  <StyledName>{formatMessage(messages.at)}</StyledName>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={timepickerLocale}>
                    <StyledTimePicker
                      PopoverProps={{
                        PaperProps: {
                          component: TimePickerPaper,
                        },
                      }}
                      ampm={usaTimeFormat}
                      disabled={
                        isFetching ||
                        isDateTimeInput(formData[FIELD_START_DATE_INPUT]) ||
                        startDateInputType === TYPE_INPUT_DATE_TIME
                      }
                      keyboardIcon={<ClockIcon />}
                      format="HH:mm:ss"
                      views={['hours', 'minutes', 'seconds']}
                      variant="inline"
                      className={cn({
                        error: Object.prototype.hasOwnProperty.call(
                          validationErrors,
                          START_TIME,
                        ),
                      })}
                      onChange={date => {
                        const newValidationErrors = { ...validationErrors }

                        delete newValidationErrors[START_TIME]

                        setValidationErrors(newValidationErrors)
                        onChangeFormValue(date, START_TIME)
                      }}
                      value={formData[START_TIME]}
                    />
                  </MuiPickersUtilsProvider>
                </StyledCondition>
                <StyledCondition align="center" wrap="wrap">
                  <StyledName>
                    {formatMessage(messages.setAdditionalDelay)}
                  </StyledName>
                  <SelectInput
                    disabled={isFetching}
                    label={formatMessage(messages.setAdditionalDelay)}
                    options={formattedAdditionalDelayActions}
                    value={formData[FIELD_START_DELAY]}
                    onChange={value => {
                      setFormData({
                        ...formData,
                        [FIELD_START_DELAY_DAYS]: null,
                        [FIELD_START_DELAY_SECONDS]: null,
                        [FIELD_START_DELAY]: value,
                      })
                    }}
                  />
                </StyledCondition>
                {formData[FIELD_START_DELAY] === VALUE_CUSTOM && (
                  <StyledCondition align="center" wrap="wrap">
                    <StyledName>{formatMessage(messages.days)}</StyledName>
                    <TextField
                      style={{
                        width: '54px',
                      }}
                      className={cn({
                        error: Object.prototype.hasOwnProperty.call(
                          validationErrors,
                          FIELD_START_DELAY_DAYS,
                        ),
                      })}
                      disabled={isFetching}
                      value={formData[FIELD_START_DELAY_DAYS]}
                      onChange={({ target: { value } }) => {
                        onChangeOneOfRequiredDelayItem(
                          value,
                          FIELD_START_DELAY_DAYS,
                        )
                      }}
                      type="number"
                    />
                    <StyledName>{formatMessage(messages.seconds)}</StyledName>
                    <TextField
                      style={{
                        width: '54px',
                      }}
                      className={cn({
                        error: Object.prototype.hasOwnProperty.call(
                          validationErrors,
                          FIELD_START_DELAY_SECONDS,
                        ),
                      })}
                      disabled={isFetching}
                      value={formData[FIELD_START_DELAY_SECONDS]}
                      onChange={({ target: { value } }) => {
                        onChangeOneOfRequiredDelayItem(
                          value,
                          FIELD_START_DELAY_SECONDS,
                        )
                      }}
                      type="number"
                    />
                  </StyledCondition>
                )}
                {isStartCondition && (
                  <StyledCondition align="center" wrap="wrap">
                    <StyledName>{formatMessage(messages.dueDate)}</StyledName>
                    <SelectInput
                      isValidationFailed={Object.prototype.hasOwnProperty.call(
                        validationErrors,
                        FIELD_DUE_DATE,
                      )}
                      disabled={isFetching}
                      label={formatMessage(messages.dueDate)}
                      options={formattedAdditionalDueDateActions}
                      value={formData[FIELD_DUE_DATE]}
                      onChange={value => {
                        onChangeDueDate(value)
                      }}
                    />
                  </StyledCondition>
                )}
                {formData[FIELD_DUE_DATE] === VALUE_CUSTOM && isStartCondition && (
                  <StyledCondition align="center" wrap="wrap">
                    <StyledName>{formatMessage(messages.dueDateIs)}</StyledName>
                    <TextField
                      style={{
                        width: '54px',
                      }}
                      required
                      className={cn({
                        error: Object.prototype.hasOwnProperty.call(
                          validationErrors,
                          FIELD_DUE_DATE_DAYS,
                        ),
                      })}
                      disabled={isFetching}
                      value={formData[FIELD_DUE_DATE_DAYS]}
                      onChange={({ target: { value } }) => {
                        onChangeRequiredNumberInput(value, FIELD_DUE_DATE_DAYS)
                      }}
                      type="number"
                    />
                    <StyledName>
                      {`${formatMessage(messages.days)} ${formatMessage(
                        messages.afterStartAt,
                      )}`}
                    </StyledName>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={timepickerLocale}>
                      <StyledTimePicker
                        PopoverProps={{
                          PaperProps: {
                            component: TimePickerPaper,
                          },
                        }}
                        className={cn({
                          error: Object.prototype.hasOwnProperty.call(
                            validationErrors,
                            FIELD_DUE_DATE_TIME,
                          ),
                        })}
                        ampm={usaTimeFormat}
                        disabled={isFetching}
                        keyboardIcon={<ClockIcon />}
                        variant="inline"
                        invalidLabel=""
                        onAccept={date =>
                          onChangeFormValue(date, FIELD_DUE_DATE_TIME)
                        }
                        onChange={date =>
                          onChangeFormValue(date, FIELD_DUE_DATE_TIME)
                        }
                        value={formData[FIELD_DUE_DATE_TIME]}
                      />
                    </MuiPickersUtilsProvider>
                  </StyledCondition>
                )}
              </Collapse>
            </StyledRuleSettings>
          </StyledModalBoxSection>
        </StyledFormSection>
        {hasMissingRequiredFields() && (
          <StyledErrorMessageHolder>
            <TriggersInfoIcon />
            {formatMessage(messages.fillRequiredFieldsMessage)}
          </StyledErrorMessageHolder>
        )}
        {!!customValidationErrors.length && (
          <StyledErrorMessageHolder>
            <TriggersInfoIcon />
            {customValidationErrors.map(error => (
              <div key={error}>{error}</div>
            ))}
          </StyledErrorMessageHolder>
        )}
        <StyledActionSection align="center">
          <StyledButtonHolder>
            <Button type="primary" onClick={handleSubmit}>
              {formatMessage(messages.save)}
            </Button>
            <Button
              disabled={isFetching}
              type="secondary"
              onClick={handleCloseModal}>
              {formatMessage(messages.cancel)}
            </Button>
          </StyledButtonHolder>
          {triggerRuleId && (
            <StyledSwitch>
              {active
                ? formatMessage(messages.active)
                : formatMessage(messages.inactive)}
              <Switch
                checked={active}
                onChange={onChangeStatus}
                onClick={event => {
                  event.stopPropagation()
                }}
                color="default"
              />
            </StyledSwitch>
          )}
        </StyledActionSection>
      </StyledModal>
      {featureFlags.TRIGGER_ASSIGNMENTS && (
        <AssignmentSubMenu
          isAssignmentSubModalOpened={isAssignmentSubModalOpened}
          setIsAssignmentSubModalOpened={setIsAssignmentSubModalOpened}
          triggerAssignmentData={formData[TRIGGER_ASSIGNMENTS]}
          formData={formData}
          setFormData={setFormData}
        />
      )}
    </>
  )
}

export default connect(
  state => ({
    triggerInputs: state.getIn(['jobsTriggers', 'triggerInputs']),
    isFetching: state.getIn(['jobsTriggers', 'isFetching']),
    stateFormData: state.getIn(['jobsTriggers', 'formData']),
    workflowList: state.getIn(['myJobs', 'workflowList']),
    siteList: state.getIn(['logbookForm', 'siteList']),
    tablePsfs: state.getIn(['jobsTriggers', 'tablePsfs']),
    isLoading: state.getIn(['jobsTriggers', 'isLoading']),
    locale: state.getIn(['profile', 'profile', 'locale']),
    licensee: state.getIn(['profile', 'profile', 'licensee']),
    featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
    triggerDefaultAssignments: state.getIn([
      'jobsTriggers',
      'triggerDefaultAssignments',
    ]),
    hierarchicalSiteGroups:
      state.getIn(['jobsTriggers', 'hierarchicalSiteGroups']) || List([]),
    isLoadingHierarchicalSiteGroups:
      state.getIn(['jobsTriggers', 'isLoadingHierarchicalSiteGroups']) || false,
  }),
  {
    fetchWorkflowList,
    fetchTriggerInputs,
    fetchSiteList,
    fetchTriggerExists,
    createOrUpdateTriggerRule,
    clearTriggerInputs,
    fetchTriggerTableData,
    setFormData,
    toggleTriggerRule,
    fetchTriggerRule,
    fetchTriggerDefaultAssignments,
    fetchHierarchicalSiteGroups,
  },
)(injectIntl(AddTriggerMenu))
